
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/product/[slug]",
      function () {
        return require("private-next-pages/shop/product/[slug].jsx");
      }
    ]);
  